import { defineStore } from 'pinia'

import { createDashboardActions } from './actions'
import { createDashboardState } from './state'

export {
    type DashboardFilters,
    type DashboardPermission,
    type DashboardWidget,
    type DashboardWidgetBody,
    type NumberOfOrdersPerImpositionRow,
    type OfflineOrderNotSentDetailRow
} from './types'

export const useDashboardStore = defineStore('dashboard', () => {
    const state = createDashboardState()
    const actions = createDashboardActions(state)

    return {
        ...state,
        ...actions
    }
})
